'use client';

import { useEffect } from 'react';
import Script from 'next/script';

const STOREROCKET_SCRIPT_URL = 'https://cdn.storerocket.io/widget.js';
const STOREROCKET_ACCOUNT_ID =
  process.env.NEXT_PUBLIC_STOREROCKET_ACCOUNT_ID || 'Y68Men189N';

const StorerocketClient = ({ containerId = 'storerocket' }) => {
  useEffect(() => {
    if (!STOREROCKET_ACCOUNT_ID) return;

    const init = () => {
      if (typeof window === 'undefined' || !window.StoreRocket?.init) return false;
      window.StoreRocket.init({
        selector: `.${containerId}`,
        account: STOREROCKET_ACCOUNT_ID,
      });
      return true;
    };

    if (init()) return;

    const interval = setInterval(() => {
      if (init()) clearInterval(interval);
    }, 100);

    return () => clearInterval(interval);
  }, [containerId]);

  return (
    <>
      <div className={`${containerId} min-h-150`} />
      <Script src={STOREROCKET_SCRIPT_URL} strategy="afterInteractive" />
    </>
  );
};

export default StorerocketClient;
